import Index from 'fastboot-admin/src/views/common/Index.vue'

export default [
    {
        path: '/',
        name: 'index',
        meta: {tab: false},
        component: Index,
        children:[
            {

                path: '/',
                redirect: '/doc-article/list'
            },
            {
                path: '/cms-category/list',
                name: 'cms-category-list',
                meta: {title: '分类列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/cms-category/List'),
            },
            {
                path: '/cms-category/add',
                name: 'cms-category-add',
                meta: {title: '新增分类', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/cms-category/Add'),
            },
            {
                path: '/cms-category/edit',
                name: 'cms-category-edit',
                meta: {title: '编辑分类', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/cms-category/Edit'),
            },
            {
                path: '/cms-article/list',
                name: 'cms-article-list',
                meta: {title: '产品文档列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/cms-article/List'),
            },
            {
                path: '/cms-article/add',
                name: 'cms-article-add',
                meta: {title: '新增产品文档', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/cms-article/Add'),
            },
            {
                path: '/cms-article/edit',
                name: 'doc-article-edit',
                meta: {title: '编辑产品文档', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/cms-article/Edit'),
            },
            {
                path: '/doc-article/list',
                name: 'doc-article-list',
                meta: {title: '产品文档列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/cms-article/List'),
            },
            {
                path: '/doc-article/add',
                name: 'doc-article-add',
                meta: {title: '新增产品文档', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/cms-article/Add'),
            },
            {
                path: '/doc-article/edit',
                name: 'doc-article-edit',
                meta: {title: '编辑产品文档', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/cms-article/Edit'),
            },
            {
                path: '/video-article/list',
                name: 'video-article-list',
                meta: {title: '视频文档列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/video-article/List'),
            },
            {
                path: '/video-article/add',
                name: 'video-article-add',
                meta: {title: '新增视频文档', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/video-article/Add'),
            },
            {
                path: '/video-article/edit',
                name: 'video-article-edit',
                meta: {title: '编辑视频文档', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/video-article/Edit'),
            },
            {
                path: '/notice-msg/list',
                name: 'notice-msg-list',
                meta: {title: '公告消息列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/notice-msg/List'),
            },
            {
                path: '/notice-msg/add',
                name: 'notice-msg-add',
                meta: {title: '新增公告消息', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/notice-msg/Add'),
            },
            {
                path: '/notice-msg/edit',
                name: 'notice-msg-edit',
                meta: {title: '编辑公告消息', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/notice-msg/Edit'),
            },
            {
                path: '/sys-config',
                name: 'sys-config-',
                meta: {title: 'APP设置', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/SysConfig'),
            },
            {
                path: '/user-feedback/list',
                name: 'user-feedback-list',
                meta: {title: '用户反馈', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/user-feedback/List'),
            },
            {
                path: '/device-stat/list',
                name: 'device-stat-list',
                meta: {title: '设备统计', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/device-stat/List'),
            }
        ]
    }
]
;
